import BaseApi from './BaseApi';

import { QuizProps } from 'models/form';

class QuestionnaireApi extends BaseApi {
	constructor() {
		super('/investor/quiz');
	}

	getKYC() {
		return this.httpClient.get({
			conditions: { version: 'v2', auth: true },
			url: '/current/kyc',
		});
	}

	getAML() {
		return this.httpClient.get({
			conditions: { version: 'v2', auth: true },
			url: '/current/aml',
		});
	}

	sendQuiz({ quizId, body }: QuizProps) {
		return this.httpClient.post({
			conditions: { version: 'v2', auth: true },
			url: `/${quizId}/submit`,
			body,
		});
	}
}

export const QuestionnaireService = new QuestionnaireApi();
